export default [
    {
        path:'bodegas',
        name: 'product-storages',
        children: [
            {
                path:'',
                name:'storage-list',
                component: () => import("@/modules/storages/views/ProductStoragesView.vue"),
            },
            {
                path:':id',
                name:'storage-show',
                component: () => import("@/modules/storages/views/ProductStorageView.vue"),
            },
        ]
    }
];
